import React, { createContext, useContext } from 'react';
import { PetProfileUpdateContextValue, UpdateMode } from '../types';
import { usePetProfileUpdate } from '../hooks/usePetProfileUpdate';
import { DogStage } from '../../../core/types';

const PetProfileUpdateContext = createContext<PetProfileUpdateContextValue | null>(null);

export const usePetProfileUpdateContext = (): PetProfileUpdateContextValue => {
  const context = useContext(PetProfileUpdateContext);
  if (!context) {
    throw new Error('usePetProfileUpdateContext must be used within a PetProfileUpdateProvider');
  }
  return context;
};

interface PetProfileUpdateProviderProps {
  children: React.ReactNode;
  onClose: () => void;
  mode?: UpdateMode;
  dogStageOverride?: DogStage;
  initialWeightOverride?: number;
}

export const PetProfileUpdateProvider: React.FC<PetProfileUpdateProviderProps> = ({
  children,
  onClose,
  mode = 'weight',
  dogStageOverride,
  initialWeightOverride,
}) => {
  const value = usePetProfileUpdate({ onClose, mode, dogStageOverride, initialWeightOverride });

  return (
    <PetProfileUpdateContext.Provider value={value}>{children}</PetProfileUpdateContext.Provider>
  );
};
